import { SnackbarProgrammatic as Snackbar } from "buefy";

class Notificator {
  constructor() {
    this.config = {
      queue: false
    };
  }

  open(config) {
    this.config.message = config.message || "";
    this.config.type = "is-" + config.type || "is-info";
    Snackbar.open(this.config);
  }
}

export default new Notificator();
